import { render, staticRenderFns } from "./BannerHoney.vue?vue&type=template&id=2d360b9a&scoped=true&"
import script from "./BannerHoney.vue?vue&type=script&lang=js&"
export * from "./BannerHoney.vue?vue&type=script&lang=js&"
import style0 from "./BannerHoney.vue?vue&type=style&index=0&id=2d360b9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d360b9a",
  null
  
)

export default component.exports